import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lat", "lng", "link"]

  connect() {
    this.updateHref()
  }

  input() {
    this.updateHref()
  }

  updateHref() {
    if (!this.hasLinkTarget) return
    if (!this.hasLatTarget || !this.hasLngTarget) return
    const lat = this.latTarget.value
    const lng = this.lngTarget.value
    const link = this.linkTarget
    const linkUrlParts = link.href.split("/")
    const coordinates = linkUrlParts.pop().split(",")
    if (coordinates.length < 2) return
    coordinates[0] = lat
    coordinates[1] = lng
    link.href = linkUrlParts.join("/") + "/" + coordinates.join(",")
  }
}
